export default "### Competitive interest rates\n\nGenerally lower than a personal loan because they’re secured against the car\n";